<template>
  <section-main class="manifest">
    <section-title title="love" />
    <h2 class="copy--heading copy--heading-first">ma<br>ni<br>fest</h2>
    <manifest-animation/>
    <div class="copy-cols-wrap">
      <text-highlight
        class="copy copy--right copy-col-6-centered copy-col-6-centered--left"
      >Nasz manifest to dwa znaki graficzne, które wyznaczają nasze podejście do tego co robimy na&nbsp;codzień.
      </text-highlight>
      <text-highlight class="copy copy-col-6-centered copy-col-6-centered--right">
        W naszym sygnecie ukryta jest szcześliwa liczba 7, do&nbsp;której za&nbsp;każdym razem dokładamy prawdziwe
        <span
          class="secret"
          @click.prevent="toggleSecret"
        >
          LOVE.
        </span>
      </text-highlight>
    </div>
    <div class="copy-col copy-col-6">
      <p class="copy copy--lead">Żeby<br>zrozumieć<br>musimy się<br>zakochać</p>
      <text-highlight class="copy">i z&nbsp;takim podejściem podchodzimy do każdego Klienta. Preferujemy spotkania i&nbsp;długie rozmowy.</text-highlight>
      <h2 class="copy--heading">.mamy<br>czas</h2>
    </div>
  </section-main>
</template>

<script>
import SectionTitle from '@/components/SectionTitle'
import TextHighlight from '@/components/TextHighlightAnimation/TextHighlight'
import ManifestAnimation from '@/components/ManifestAnimation'
import { mapMutations } from 'vuex'
export default {
  components: {
    SectionTitle,
    TextHighlight,
    ManifestAnimation
  },
  methods: {
    ...mapMutations(['toggleSecret'])
  }
}
</script>

<style lang="scss" scoped>
  .secret {
    cursor: pointer;
  }
  .section-manifest {
    .copy--heading {
      font-size: 60px;
      line-height: 61px;
      letter-spacing: 1.9px;
      margin-top: 50px;
      margin-bottom: 43px;
      @include media-up(sm) {
        margin-top: 60px;
        margin-bottom: 144px;
      }
      @include media-up(md) {
        margin-top: 55px;
        margin-bottom: 88px;
      }
      @include media-up(lg) {
        font-size: 132px;
        line-height: 142px;
        margin-top: 174px;
        margin-bottom: 243px;
      }
      &-first {
        margin-top: 41px;
        margin-bottom: 95px;
        font-size: 52px;
        line-height: 45px;
        @include media-up(md) {
          margin-top: 71px;
          margin-bottom: 60px;
        }
        @include media-up(lg) {
          margin-top: 98px;
          margin-bottom: 191px;
          font-size: 132px;
          line-height: 136px;
          letter-spacing: 2px;
        }
      }
    }
    .copy--lead {
      margin-bottom: 46px;
      @include media-up(sm) {
        margin-bottom: 43px;
      }
      @include media-up(lg) {
        margin-bottom: 48px;
      }
    }
    .copy-cols-wrap {
      margin-top: 78px;
      margin-bottom: 63px;
      @include media-up(sm) {
        margin-top: 77px;
        margin-bottom: 132px;
      }
      @include media-up(md) {
        margin-top: 51px;
        margin-bottom: 96px;
      }
      @include media-up(lg) {
        margin-top: 225px;
        margin-bottom: 148px;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/Manifest.vue